module.exports = __webpack_public_path__ + "img/paperboy-frontpage.3b704d9a.png";